import { render, staticRenderFns } from "./promo-code-report.vue?vue&type=template&id=23cb3af5&"
import script from "./promo-code-report.vue?vue&type=script&lang=js&"
export * from "./promo-code-report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports